import React, { Component } from "react";
import Form from "../form/Form";
import Button from "@material-ui/core/Button";
import { capitalize } from '../../utils/textTransform';
import locale from "../../utils/locale"
import "./VerificationPage.css"
import Linkify from 'react-linkify'

const fieldStructure = [
  {
    name: 'postCode',
    questionLabel: "Zipcode of Pickup Address",
    label: locale('Zip_Code'),
    type: 'text',
    readable: true,
    editable: true,
    required: true,
    maxLength: 20,
    regEx: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
    transform: capitalize,
    helpText: locale("zipCodeHelpText")
  }
]
const style = {
  background: '#0A5DB8',
};


class VerificationPage extends Component {

  state = {
    errors: {
      postCode: true
    },
    errorMessage: "",
    showError: false,
    postCode: '',
  };


  handleChange = (name, value, error) => {
    this.setState({
      [name]: value,
      errors: { ...this.state.errors, [name]: error },
    })
  }

  handleClick = () => {
    if (!this.state.errors.postCode) {
      this.props.handleVerify(this.state.postCode.trim());
    } else {
      this.setState({
        showError: true
      })
    }
  }

  render() {
    const {
      stepTitle,
      stepIntroText,
      message,
      text_message
    } = this.props;
    return (
      <div>
        <div className="intro-title">{stepTitle}</div>
        <div className="intro-text">{stepIntroText}</div>
        <div className="step-form lot-validation">
          <div className="verification-page-message">
            {text_message}
          </div>
          <div className="verification-page-message">
            <Linkify >{message}</Linkify>
          </div>
          <br></br>
          <Form
            fieldsStructure={fieldStructure}
            handleFieldChange={this.handleChange}
            showErrors={this.state.showError}
            valueObj={{ postCode: this.state.postCode }}
            fields={{}}
          />
          <Button
            className="br-25"
            onClick={this.handleClick}
            variant="raised"
            color="primary"
            fullWidth
            style={style}
          >
            <strong> {locale("verify")} </strong>
          </Button>
        </div>
      </div>
    );
  }
}

export default VerificationPage;


// WEBPACK FOOTER //
// ./src/components/VerificationPage/index.js